import { gql } from '@apollo/client';

const EXCHANGE_AUTH_CODE = gql`
  mutation ExchangeAuthCode($code: String!) {
    exchangeAuthCode(code: $code) {
      payload
      refreshExpiresIn
      token
      refreshToken
    }
  }
`;

export default EXCHANGE_AUTH_CODE;

